import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import ClosableDialog from '../ClosableDialog';
import IntlPropType from '../../intl';


const messages = defineMessages({
  ok: { id: 'ok' },
  cancel: { id: 'cancel' },
  content: { id: 'endMeetingDialogContent' },
  title: { id: 'endMeetingDialogTitle' },
});


class EndMeetingDialog extends Component {
  render() {
    return (
      <ClosableDialog
        open={this.props.open}
        onClose={this.props.onCancel}
        disableBackdropClick
        maxWidth="xs"
        title={this.props.intl.formatMessage(messages.title)}
      >
        <DialogContent>
          <DialogContentText>
            {this.props.intl.formatMessage(messages.content)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onConfirm} variant="contained" color="primary">
            {this.props.intl.formatMessage(messages.ok)}
          </Button>
        </DialogActions>
      </ClosableDialog>
    );
  }
}


EndMeetingDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  intl: IntlPropType.isRequired,
};


export default injectIntl(EndMeetingDialog);
